import styles from "./HeroAttributes.module.scss";

type Props = {
  title: string;
};

export const HeroAttributesUI = ({ title }: Props) => (
  <div data-component="HeroAttributes">
    <h2 className={styles.title}>HeroAttributes component for {title}</h2>
  </div>
);
